import React from 'react';
import { Tooltip, Marker } from 'react-leaflet';
import L from 'leaflet';
import transparentImg from '../../icons/transparent.png';
import { BuildingFeature } from 'types/venue';

type BuildingLabelType = { buildingName: string; buildingFeature: BuildingFeature };

export default function BuildingLabelTooltip({ buildingName, buildingFeature }: BuildingLabelType) {
  const displayPoint: any = [...buildingFeature.properties.display_point.coordinates].reverse(); // reversed to correct order

  const customIcon = new L.Icon({
    iconUrl: transparentImg, // 1px alpha image to show nothing.
    iconSize: new L.Point(0, 0),
  });

  return (
    <Marker icon={customIcon} position={displayPoint}>
      <Tooltip className="tooltip-building" direction="center" permanent opacity={1}>
        {buildingName}
      </Tooltip>
    </Marker>
  );
}
